import './style.scss';
import Highcharts from 'highcharts';

var techGDP = {
	load() {
		jQuery
			.when(
				jQuery.Deferred((deferred) => {
					jQuery('#js-tech-gdp').html(
						'<p class="subtitle">Adults who ...</p><div class="ui top attached tabular menu"> <a class="item active" data-tab="first">Use the internet*</a> <a class="item" data-tab="second">Own a smartphone†</a></div><div id="use-internet" class="ui bottom attached tab segment active" data-tab="first"><p class="instructions">Roll over points to view individual country data.</p><p class="correlation">Correlation: <span>0.87</span></p><div id="chart1"></div></div><div id="own-smartphone" class="ui bottom attached tab segment" data-tab="second"><p class="instructions">Roll over points to view individual country data.</p><p class="correlation">Correlation: <span>0.84</span></p><div id="chart2"></div></div><p class="source">† Includes adults who report owning a smartphone.</p><p class="source">Note: Percentages based on total sample. IMF data not available for Palestinian territories.</p><p class="source">Source: Spring 2015 Global Attitudes survey. Q71 & Q72. Data for GDP per capita (PPP) from IMF World Economic Outlook Database, October 2015, accessed Dec. 16, 2015.</p>',
					);
					jQuery(deferred.resolve);
				}),
			)
			.done(() => {
				techGDP.initCharts();
				jQuery('.menu .item').tab();
			});
	},
	initCharts(data) {
		const internetChart = {
			credits: { enabled: false },
			exporting: { enabled: false },
			colors: [
				'#a8a8a8',
				'#949d48',
				'#456a83',
				'#746a7e',
				'#a55a26',
				'#bf3b27',
				'#ea9e2c',
				'#1d1b12',
			],
			chart: {
				marginBottom: 40,
				marginRight: 0,
				renderTo: 'chart1',
			},
			xAxis: {
				min: 0,
				max: 60001,
				showLastLabel: true,
				title: {
					text: '2015 GDP per capita (PPP, current international $)',
					style: {
						fontFamily: '"franklin-gothic-urw",Verdana,Geneva,sans-serif',
						color: '#888',
						fontSize: '1em',
					},
					offset: 38,
				},
				labels: {
					formatter() {
						return `$${Highcharts.numberFormat(this.value, 0, '.', ',')}`;
					},
				},
			},
			yAxis: {
				title: {
					align: 'middle',
					offset: 40,
					text: '% of adult internet users',
					rotation: 270,
					style: {
						fontFamily: '"franklin-gothic-urw",Verdana,Geneva,sans-serif',
						color: '#888',
						fontSize: '1em',
						lineHeight: '15',
					},
				},
				gridLineDashStyle: 'Dot',
				gridLineColor: '#ccc',
				min: 0,
				max: 100,
			},
			title: {
				text: '',
			},
			tooltip: {
				formatter() {
					let s = `<b>${this.point.name}</b><br/>`;
					s += `% of adult internet users: <b>${this.y}%</b><br/>`;
					s += `GDP per capita: <b>$${Highcharts.numberFormat(
						this.x,
						0,
						'.',
						',',
					)}</b>`;
					return s;
				},
			},
			plotOptions: {
				spline: {
					states: {
						hover: {
							lineWidth: 1,
						},
					},
				},
			},
			legend: {
				layout: 'vertical',
				align: 'left',
				verticalAlign: 'bottom',
				x: 450,
				y: -30,
				floating: true,
			},
			series: [
				{
					type: 'spline',
					showInLegend: false,
					marker: {
						enabled: false,
						states: {
							hover: {
								enabled: false,
							},
						},
					},
					enableMouseTracking: false,
					data: [
						[0, 28.773],
						[60000, 112.773],
					],
				},
				{
					type: 'scatter',
					name: 'Africa',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'Burkina Faso', x: 1738.8, y: 18 },
						{ name: 'Ethiopia', x: 1773.88, y: 8 },
						{ name: 'Ghana', x: 4215.86, y: 25 },
						{ name: 'Kenya', x: 3245.53, y: 40 },
						{ name: 'Nigeria', x: 6184.74, y: 39 },
						{ name: 'Senegal', x: 2425.45, y: 31 },
						{ name: 'South Africa', x: 13197.3, y: 42 },
						{ name: 'Tanzania', x: 2900.75, y: 21 },
						{ name: 'Uganda', x: 1999.33, y: 11 },
					],
				},
				{
					type: 'scatter',
					name: 'Asia/Pacific',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'Australia', x: 47317.97, y: 93 },
						{ name: 'China', x: 14189.52, y: 65 },
						{ name: 'India', x: 6209.48, y: 22 },
						{ name: 'Indonesia', x: 11111.82, y: 30 },
						{ name: 'Japan', x: 38210.63, y: 69 },
						{ name: 'Malaysia', x: 26141.13, y: 68 },
						{ name: 'Pakistan', x: 4902.09, y: 15 },
						{ name: 'Philippines', x: 7318.39, y: 40 },
						{ name: 'South Korea', x: 36528.39, y: 94 },
						{ name: 'Vietnam', x: 6019.51, y: 50 },
					],
				},
				{
					type: 'scatter',
					name: 'Europe',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'France', x: 41221.47, y: 75 },
						{ name: 'Germany', x: 47033.23, y: 85 },
						{ name: 'Italy', x: 35664.91, y: 72 },
						{ name: 'Poland', x: 26402.84, y: 69 },
						{ name: 'Spain', x: 35269.83, y: 87 },
						{ name: 'United Kingdom', x: 40958.23, y: 88 },
					],
				},
				{
					type: 'scatter',
					name: 'Russia/Ukraine',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'Russia', x: 23744.22, y: 72 },
						{ name: 'Ukraine', x: 7989.64, y: 60 },
					],
				},
				{
					type: 'scatter',
					name: 'Latin America',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'Argentina', x: 22375.19, y: 71 },
						{ name: 'Brazil', x: 15690.13, y: 60 },
						{ name: 'Chile', x: 23563.7, y: 78 },
						{ name: 'Mexico', x: 18334.99, y: 54 },
						{ name: 'Peru', x: 12076.72, y: 52 },
						{ name: 'Venezuela', x: 15891.69, y: 67 },
					],
				},
				{
					type: 'scatter',
					name: 'Middle East',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'Israel', x: 33658.27, y: 86 },
						{ name: 'Jordan', x: 12162.13, y: 67 },
						{ name: 'Lebanon', x: 18416.63, y: 66 },
						{ name: 'Turkey', x: 20276.99, y: 72 },
					],
				},
				{
					type: 'scatter',
					name: 'North America',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'Canada', x: 45488.9, y: 90 },
						{
							name: 'United States',
							x: 55904.3,
							y: 89,
							dataLabels: {
								enabled: true,
								align: 'right',
								style: {
									fontWeight: 'bold',
								},
								formatter() {
									return this.point.name;
								},
								x: 40,
								y: -5,
								// overflow: true,
								crop: false,
							},
							marker: {
								lineWidth: 1,
								lineColor: '#333',
							},
						},
					],
				},
			],
		};

		const smartphoneChart = {
			credits: { enabled: false },
			exporting: { enabled: false },
			colors: [
				'#a8a8a8',
				'#949d48',
				'#456a83',
				'#746a7e',
				'#a55a26',
				'#bf3b27',
				'#ea9e2c',
				'#1d1b12',
			],
			chart: {
				marginBottom: 40,
				marginRight: 0,
				renderTo: 'chart1',
			},
			xAxis: {
				min: 0,
				max: 60001,
				showLastLabel: true,
				title: {
					text: '2015 GDP per capita (PPP, current international $)',
					style: {
						fontFamily: '"franklin-gothic-urw",Verdana,Geneva,sans-serif',
						color: '#888',
						fontSize: '1em',
					},
					offset: 38,
				},
				labels: {
					formatter() {
						return `$${Highcharts.numberFormat(this.value, 0, '.', ',')}`;
					},
				},
			},
			yAxis: {
				title: {
					align: 'middle',
					offset: 40,
					text: '% who report owning a smartphone',
					rotation: 270,
					style: {
						fontFamily: '"franklin-gothic-urw",Verdana,Geneva,sans-serif',
						color: '#888',
						fontSize: '1em',
						lineHeight: '15',
					},
				},
				gridLineDashStyle: 'Dot',
				gridLineColor: '#ccc',
				min: 0,
				max: 100,
			},
			title: {
				text: '',
			},
			tooltip: {
				formatter() {
					let s = `<b>${this.point.name}</b><br/>`;
					s += `% who report owning a smartphone: <b>${this.y}%</b><br/>`;
					s += `GDP per capita: <b>$${Highcharts.numberFormat(
						this.x,
						0,
						'.',
						',',
					)}</b>`;
					return s;
				},
			},
			plotOptions: {
				spline: {
					states: {
						hover: {
							lineWidth: 1,
						},
					},
				},
			},
			legend: {
				layout: 'vertical',
				align: 'left',
				verticalAlign: 'bottom',
				x: 450,
				y: -30,
				floating: true,
			},
			series: [
				{
					type: 'spline',
					// name: 'y = - 35.081 + 8.9169ln(x)',
					showInLegend: false,
					marker: {
						enabled: false,
						states: {
							hover: {
								enabled: false,
							},
						},
					},
					enableMouseTracking: false,
					data: [
						[0, 18.089],
						[60000, 90.089],
					],
				},
				{
					type: 'scatter',
					name: 'Africa',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'Burkina Faso', x: 1738.8, y: 14 },
						{ name: 'Ethiopia', x: 1773.88, y: 4 },
						{ name: 'Ghana', x: 4215.86, y: 21 },
						{ name: 'Kenya', x: 3245.53, y: 26 },
						{ name: 'Nigeria', x: 6184.74, y: 28 },
						{ name: 'Senegal', x: 2425.45, y: 19 },
						{ name: 'South Africa', x: 13197.3, y: 37 },
						{ name: 'Tanzania', x: 2900.75, y: 11 },
						{ name: 'Uganda', x: 1999.33, y: 4 },
					],
				},
				{
					type: 'scatter',
					name: 'Asia/Pacific',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'Australia', x: 47317.97, y: 77 },
						{ name: 'China', x: 14189.52, y: 58 },
						{ name: 'India', x: 6209.48, y: 17 },
						{ name: 'Indonesia', x: 11111.82, y: 21 },
						{ name: 'Japan', x: 38210.63, y: 39 },
						{ name: 'Malaysia', x: 26141.13, y: 65 },
						{ name: 'Pakistan', x: 4902.09, y: 11 },
						{ name: 'Philippines', x: 7318.39, y: 22 },
						{ name: 'South Korea', x: 36528.39, y: 88 },
						{ name: 'Vietnam', x: 6019.51, y: 35 },
					],
				},
				{
					type: 'scatter',
					name: 'Europe',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'France', x: 41221.47, y: 49 },
						{ name: 'Germany', x: 47033.23, y: 60 },
						{ name: 'Italy', x: 35664.91, y: 60 },
						{ name: 'Poland', x: 26402.84, y: 41 },
						{ name: 'Spain', x: 35269.83, y: 71 },
						{ name: 'United Kingdom', x: 40958.23, y: 68 },
					],
				},
				{
					type: 'scatter',
					name: 'Russia/Ukraine',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'Russia', x: 23744.22, y: 45 },
						{ name: 'Ukraine', x: 7989.64, y: 27 },
					],
				},
				{
					type: 'scatter',
					name: 'Latin America',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'Argentina', x: 22375.19, y: 48 },
						{ name: 'Brazil', x: 15690.13, y: 41 },
						{ name: 'Chile', x: 23563.7, y: 65 },
						{ name: 'Mexico', x: 18334.99, y: 35 },
						{ name: 'Peru', x: 12076.72, y: 25 },
						{ name: 'Venezuela', x: 15891.69, y: 45 },
					],
				},
				{
					type: 'scatter',
					name: 'Middle East',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'Israel', x: 33658.27, y: 74 },
						{ name: 'Jordan', x: 12162.13, y: 51 },
						{ name: 'Lebanon', x: 18416.63, y: 52 },
						{ name: 'Turkey', x: 20276.99, y: 59 },
					],
				},
				{
					type: 'scatter',
					name: 'North America',
					marker: { symbol: 'circle', radius: 5 },
					data: [
						{ name: 'Canada', x: 45488.9, y: 67 },
						{
							name: 'United States',
							x: 55904.3,
							y: 72,
							dataLabels: {
								enabled: true,
								align: 'right',
								style: {
									fontWeight: 'bold',
								},
								formatter() {
									return this.point.name;
								},
								x: 40,
								y: -5,
								// overflow: true,
								crop: false,
							},
							marker: {
								lineWidth: 1,
								lineColor: '#333',
							},
						},
					],
				},
			],
		};

		jQuery('#chart1').highcharts(internetChart);
		jQuery('#chart2').highcharts(smartphoneChart);
	},
};

jQuery(document).ready(($) => {
	techGDP.load();
});
